<div class="container">
    <div *ngIf="isLoading" class="row justify-content-center">
        <fa-icon class="fa-5x fa-spin hight-width-50" [rotate]="rotate" [icon]="faSpinner"></fa-icon>
    </div>
    <div [ngStyle]="{'margin-top': marginTop+'px'}"></div>
</div>

